/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsVialFlask: {
  name: 'vial-flask';
  data: string;
} = {
  name: 'vial-flask',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 2h5a1 1 0 1 1 0 2v4.697l1.832 2.748a1 1 0 0 1-1.664 1.11l-1.832-2.748A2 2 0 0 1 11 8.697V4H9v4.73a2 2 0 0 1-.272 1.007L2.74 20H14a1 1 0 1 1 0 2H2.741c-1.544 0-2.505-1.674-1.728-3.008L7 8.73V4a1 1 0 0 1 0-2h1Zm7 1a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2v15a3 3 0 1 1-6 0V4a1 1 0 0 1-1-1Zm3 1v15a1 1 0 1 0 2 0V4h-2Z" fill="currentColor"/></svg>`,
};
